// BranchPage.tsx - İyileştirilmiş versiyon
import React, { FC, useEffect, useState, useCallback } from 'react'
import { Form, Formik, FormikProps } from 'formik'
import { ConfirmModal } from '../../../../shared/components/ConfirmModal'
import { tabOptions } from '../../definition/insuranc-expense/InsuranceExpenseModel'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { showErrorToast, showSuccessToast } from '../../../../shared/components/ToastUtils'
import { createInspectionExpense, updateInspectionExpense, deleteInspectionExpense, loadInspectionExpense } from './Api'
import FormTabHeader, { TabOption } from '../../../../shared/components/FormTabHeader'

import { IInspectionExpense, initialInspectionExpense, validationInspectionExpense } from './InspectionExpenseModel'




const InspectionExpensePage: FC = () => {
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [selectedId, setSelectedId] = useState<string | null | undefined>(null)
    const [tab, setTab] = useState<string | 'form'>('form')
    const [error, setError] = useState<string | null>(null)


    const handleSave = async (values: IInspectionExpense, resetForm: () => void) => {
        setLoading(true)
        try {
            if (selectedId) {
                await updateInspectionExpense({ ...values, id: selectedId })
                showSuccessToast('Şube başarıyla güncellendi')
            } else {
                await createInspectionExpense(values)
                showSuccessToast('Şube başarıyla oluşturuldu')
            }

            resetForm()
            setSelectedId(null)
            setTab('form')
        } catch (err) {
            showErrorToast('Bir hata oluştu')
        } finally {
            setLoading(false)
        }
    }

    const handleDelete = async () => {
        if (selectedId) {
            setLoading(true)
            try {
                await deleteInspectionExpense(selectedId)
                showSuccessToast('Şube başarıyla silindi')

            } catch (err) {
                console.error(err)
                showErrorToast('Şube silinirken bir hata oluştu')
            } finally {
                setLoading(false)
                setShowModal(false)
                setSelectedId(null)
            }
        }
    }
    return (
        <>
            <Formik
                initialValues={initialInspectionExpense}
                validationSchema={validationInspectionExpense}
                enableReinitialize
                onSubmit={(values, { resetForm }) => handleSave(values, resetForm)}
            >
                {(formik) => {
                    const handleReset = () => {
                        formik.resetForm();
                        setSelectedId(null);
                        setTab('form');
                    };

                    return (
                        <>
                            <FormTabHeader
                                formId="InspectionExpenseForm"
                                formikSubmit={formik.handleSubmit}
                                formikReset={handleReset}
                                loading={loading}
                                tab={tab}
                                setTab={setTab}
                                setSelectedId={setSelectedId}
                                tabs={tabOptions}
                                onExportExcel={() => console.log('Excel export')}
                            />

                            <div className="card mb-5">
                                <Form id="InspectionExpenseForm" className="form card-body">
                                    {tab === 'form' && (
                                        <>
                                            {/* form alanları */}
                                        </>
                                    )}

                                    {tab === 'odeme' && (
                                        <>
                                            {/* detay alanları */}
                                        </>
                                    )}
                                    {tab === 'arac' && (
                                        <>
                                            {/* detay alanları */}
                                        </>
                                    )}
                                </Form>
                            </div>
                        </>
                    );
                }}
            </Formik>

            <ConfirmModal
                show={showModal}
                header="Silme Onayı"
                text="Bu şubeyi silmek istediğinize emin misiniz?"
                handleClose={() => {
                    setShowModal(false);
                    setSelectedId(null);
                }}
                applyOnClick={handleDelete}
            />

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
}
export { InspectionExpensePage }